module.exports = __webpack_public_path__ + "img/rtrain.6fea59d1.svg";